<template>
  <div class="pokedex-wrapper">
    <div v-if="!pokedex || !pokedex.data" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="text-muted mt-2">Loading pokedex...</p>
    </div>
    
    <div v-else class="animated fadeIn">
      <!-- Pokedex Grid -->
      <div class="rounded shadow-sm border" style="min-height: 500px;">
        <PokedexRecords 
          :records="pokedex.data.data" 
          :server="pokedex.data.server"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import PokedexRecords from './PokedexRecords'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Pokedex',
    components: {
      PokedexRecords
    },
    props: {
      username: { type: String, required: true },
      server: { type: String, required: true }
    },
    computed: mapGetters({
      pokedex: 'pokedex'
    }),
    watch: {
      username: 'fetchData',
      server: 'fetchData'
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData() {
        if (this.username && this.server) {
          this.emit('getPokedex', {
            username: this.username, 
            server: this.server
          })
        }
      }
    }
  }
</script>
